<template>
  <SysDialog
    v-model="dialog_ativo"
    :txt-botao="txt_botao"
    :titulo="props.titulo"
    :largura="props.largura || 350"
    :ocultar-acoes="props.ocultar_acoes"
    @click:primary="confirmar"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>

    <div class="pb-2 font-14">
      {{ props.texto_confirmacao }}
    </div>
  </SysDialog>
</template>

<script setup>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import {ref} from "vue";

const props = defineProps({
  titulo: {
    type: String,
    default: 'Confirmação'
  },
  texto_confirmacao: {
    type: String,
    default: ''
  },
  largura: Number,
  txt_botao: {
    type: String,
    default: 'confirmar'
  },
  ocultar_acoes: Boolean
});

const emit = defineEmits(['confirmacao']);

const dialog_ativo = ref(false);

function confirmar() {
  dialog_ativo.value = false;
  emit('confirmacao', {});
}
</script>

<style scoped>

</style>
